import React from 'react';
import { Link } from 'react-router-dom';
import { localizePath, useLang } from '../i18n';
import HeroVideo from '../images/hero_animasyon.mp4';
import HeroPoster from '../images/hero_animasyon_poster.jpg';

const TEXT = {
    tr: {
        tagline: 'Nitelikli ürün üretme ve zamanında teslimat ilkeleriyle çözüm ortağınız.',
        services: 'Hizmetlerimiz',
        contact: 'İletişim',
    },
    en: {
        tagline: 'Your solution partner, built on quality products and on-time delivery.',
        services: 'Our Services',
        contact: 'Contact',
    },    de: {
        tagline: 'Ihr Lösungspartner für hochwertige Produkte und pünktliche Lieferung.',
        services: 'Unsere Leistungen',
        contact: 'Kontakt',
    },
};

// The animation itself reveals the logo and company name, so the hero only adds
// the tagline and buttons along the bottom (below the video on phones).
const Hero = () => {
    const lang = useLang();
    const t = TEXT[lang];

    return (
        <section className="relative bg-[#0b0e14]">
            <h1 className="sr-only">AKKA DEMİR ÇELİK</h1>

            <div className="relative w-full aspect-video md:max-h-[calc(100vh-4rem)] overflow-hidden">
                <video
                    className="absolute inset-0 w-full h-full object-cover motion-reduce:hidden"
                    autoPlay
                    loop
                    muted
                    playsInline
                    poster={HeroPoster}
                    aria-hidden="true"
                >
                    <source src={HeroVideo} type="video/mp4" />
                </video>
                {/* The final frame (logo and name) replaces the video for reduced-motion users */}
                <img src={HeroPoster} alt="" className="hidden motion-reduce:block absolute inset-0 w-full h-full object-cover" />
            </div>

            <div className="hidden md:block pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/85 via-black/40 to-transparent"></div>

            <div className="md:absolute md:inset-x-0 md:bottom-0">
                <div className="container mx-auto px-4 py-6 md:pb-8 flex flex-col md:flex-row items-center md:items-end justify-between gap-5 text-center md:text-left">
                    <p className="text-lg md:text-2xl text-gray-100 font-light max-w-xl m-0">
                        {t.tagline}
                    </p>
                    <div className="flex flex-wrap justify-center gap-4 shrink-0">
                        <a href="#services" className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white hover:text-white font-semibold rounded-lg transition duration-300">
                            {t.services}
                        </a>
                        <Link to={localizePath('/contact', lang)} className="px-8 py-3 bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-900 font-semibold rounded-lg transition duration-300">
                            {t.contact}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
